import { RootState } from 'rootReducer';

export const branchSelector = (state: RootState) => state.adiminModuleReducer.branchReducer;
